<template>
  <div class="c-tabswitch">
    <div class="c-tabswitch__item" v-for="(item, index) in items" :key="item">
      <input
        type="radio"
        class="c-tabswitch__radio"
        :name="name"
        :id="`${name}${index}`"
        :checked="index === 0"
      />
      <label :for="`${name}${index}`" class="c-tabswitch__button">{{
        item
      }}</label>
    </div>
  </div>
</template>

<script>
// @group Base Components
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.c-tabswitch {
  display: flex;

  & + & {
    margin-top: 1.6rem;
  }
}

.c-tabswitch__item {
  flex: 1 1 auto;
}

.c-tabswitch__radio {
  display: none;
}

.c-tabswitch__button {
  border: 0.1rem solid $gray-100;
  border-left-width: 0;
  display: block;
  padding: 0.8rem;
  position: relative;
  text-align: center;

  .c-tabswitch__radio:checked + & {
    background: rgba($primary-color, 0.1);
    background: var(--primary-color-light);
    border-color: $primary-color;
    border-color: var(--primary-color);
    border-left-width: 0.1rem;
    border-left-style: solid;
    color: $primary-color;
    color: var(--primary-color);
  }
}

.c-tabswitch__item:not(:last-child)
  .c-tabswitch__radio:checked
  + .c-tabswitch__button {
  margin-right: -0.1rem;
  z-index: 1;
}

.c-tabswitch__item:not(:first-child)
  .c-tabswitch__radio:checked
  + .c-tabswitch__button {
  margin-left: -0.1rem;
  z-index: 1;
}

.c-tabswitch__item:first-child .c-tabswitch__button {
  border-radius: $border-radius-small 0 0 $border-radius-small;
  border-left-width: 0.1rem;
}

.c-tabswitch__item:last-child .c-tabswitch__button {
  border-radius: 0 $border-radius-small $border-radius-small 0;
}
</style>
